import axios from 'axios';

import { ContactFormItem } from './contactFormItem';

const api = 'https://pmcontactform.azurewebsites.net/api/formHandler';

class AppService {
    constructor() {
        console.log('creating new instance of app.service');
    }
    submitForm(form: ContactFormItem) {
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        return axios.post('https://pmcontactform.azurewebsites.net/api/formHandler', form);
    }
    
}

// Export a singleton instance in the global namespace
export const appService = new AppService();